import { Component} from '@angular/core';

@Component({
    selector: 'commitment-main',
    templateUrl: './commitment-main.tmpl.html'
})

export class CommitmentMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  